const DEFAULTS =   {
  // Selector used to find the observable children
  attrSelector: 'data-cl-reveal',
  direction: 'fromTop',
};

/**
 * Links 2 or more elements so that,
 * when hovering the cursor over one element,
 * another element will be displayed with simple "swipe" animation.
 *
 * This class can be used to display a submenu or tooltip
 * when hovering over an element.
 *
 * This class uses two attribute selectors:
 * [data-cl-reveal="name"]                              This selector is placed on the element to be hidden/displayed
 *                                                     The attribute's value will be the name of this component.
 * [data-cl-reveal-trigger-for="name"]  This selector is placed on the element(s) to that trigger the show/hide state
 *                                                     The attribute's value should match that of data-cl-reveal
 *
 * The base of these attributes can be overwritten to use a custom selector using the follow format:
 * [${attrSelector}="name"]
 * [${attrSelector}-trigger-for="name"]
 */
export default class HoverReveal {

  constructor(el, options = DEFAULTS) {
    this.options = {...DEFAULTS, ...options};
    this.el = el;
    if (!this.el) console.error('[HoverReveal] Initialized without an element.');
    this.name = this.el.getAttribute(this.options.attrSelector);
    if (!this.name) console.warn(`[HoverReveal] No value was set for attribute '${this.options.attrSelector}'`);
    this.hoverTriggerElements = document.querySelectorAll(`[${this.options.attrSelector}-trigger-for="${this.name}"]`);
    if (this.hoverTriggerElements.length === 0) console.warn(`[HoverReveal] No triggers were found for HoverReveal named '${this.name}'. Proper trigger selector is [${this.options.attrSelector}-trigger-for="${this.name}"]`);

    // Do this before setting any styles
    if (module.hot) this.hotModuleInit();

    // Override direction option with value defined in markup
    this.options.direction = this.el.dataset.clRevealDirection || this.options.direction;
    this.setClipDirection();

    this.applyClip();
    this.startHoverListener();
  }

  startHoverListener() {
    this.hoverTriggerElements.forEach(el => {
      el.addEventListener('mouseover', () => this.removeClip());
      el.addEventListener('mouseleave', () => this.applyClip());
    });

    this.el.addEventListener('mouseover', () => this.removeClip());
    this.el.addEventListener('mouseleave', () => this.applyClip());
  }

  setClipDirection() {
    switch (this.options.direction) {
    case 'fromTop':
      this.clipPath = 'inset(0 0 100% 0)';
      break;
    case 'fromLeft':
      this.clipPath = 'inset(0 100% 0 0)';
      break;
    // TODO: Add more options for each direction
    default:
      console.error(`[hoverReveal] Animation '${this.options.direction}' is not a valid name.`);
    }

    Object.assign(this.el.style, {
      transition: 'clip-path ease-out 150ms',
    });

  }

  applyClip() {
    Object.assign(this.el.style, {
      clipPath: this.clipPath,
    });
  }

  removeClip() {
    Object.assign(this.el.style, {
      clipPath: 'inset(0)',
    });
  }

  hotModuleInit() {
    // The original markup without eventListeners.
    this.markup = this.el.cloneNode(true);
    this.markup.style = '';
    this.parentEl = this.el.parentElement;
    this.nextSibling = this.el.nextSibling;
  }

}
